<template>
    <form action="" v-on:submit.prevent="login" class="login">
        <div class="login-control">
            <div class="input-icon" :class="emailStates">
                <i class="icon ico-mail"></i>
            </div>
            <input type="email" class="login-input" placeholder="email@email.com" v-model="email">
            <span class="login-input-error" v-if=error.email >{{ error.email }}</span>
        </div>
        <div class="login-control">
            <div class="input-icon" :class="{ 'input-icon-error': error.credentials, 'input-icon-ok': ok.credentials  }">
                <i class="icon ico-lock"></i>
            </div>
            <input type="password" class="login-input" placeholder="*********" v-model="password">
            <span class="login-input-error" v-if=error.credentials >{{ error.credentials }}</span>
        </div>
        
        <!-- <input class="btn login" :class="{ 'btn login active': ok.form }" :disabled="!ok.form" type="submit" value="Ingresar" @click="login()" /> -->

        <button class="btn login" :class="{ 'active ': ok.form, 'loading': loading }" :disabled="!ok.form"  @click="login()" >
            <p v-show="!loading">Ingresar</p>
            <svg v-show="loading" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="32px" height="32px" viewBox="0 0 40 40" enable-background="new 0 0 40 40" xml:space="preserve">
                <path opacity="0.2" fill="#fff" d="M20.201,5.169c-8.254,0-14.946,6.692-14.946,14.946c0,8.255,6.692,14.946,14.946,14.946 s14.946-6.691,14.946-14.946C35.146,11.861,28.455,5.169,20.201,5.169z M20.201,31.749c-6.425,0-11.634-5.208-11.634-11.634 c0-6.425,5.209-11.634,11.634-11.634c6.425,0,11.633,5.209,11.633,11.634C31.834,26.541,26.626,31.749,20.201,31.749z"/>
                <path fill="#fff" d="M26.013,10.047l1.654-2.866c-2.198-1.272-4.743-2.012-7.466-2.012h0v3.312h0 C22.32,8.481,24.301,9.057,26.013,10.047z">
                <animateTransform attributeType="xml"
                    attributeName="transform"
                    type="rotate"
                    from="0 20 20"
                    to="360 20 20"
                    dur="0.5s"
                    repeatCount="indefinite"/>
            </path>
            </svg>
        </button>
        <a class="forget-password" target="_blank" href="https://forms.monday.com/forms/8be586a607fecae8c48fb37d89319dd1?r=use1">¿Olvidaste tu contraseña?</a>
    </form>
</template>

<script>
import { mapActions } from 'vuex';

export default {
    name : 'LoginForm',
    data: function(){
        return {
            email: '',
            password: '',
            error: {email:null,credentials:null},
            ok: {email:false, credentials:false, form:false},
            loading: false,
            re: /^([a-zA-Z0-9_.+-])+\@(([a-zA-Z0-9-])+\.)+([a-zA-Z0-9]{2,4})+$/
            
        }
    },
    computed: {
        emailStates: function() {
            return {
            'input-icon-error': this.error.credentials || this.error.email,
            'input-icon-ok': this.ok.email
            }
        },
        passwordStates: function() {
            return {
            'input-icon-error': this.error.credentials,
            'input-icon-ok': this.ok.credentials
            }
        }
        },
        methods: {
            login: function(){
                this.loading = true
                this.error.email = null;
                this.error.credentials = null;
                this.userLogin({'email':this.email,'password':this.password})
                    .then(r => {
                        var response = JSON.parse(r)
                        localStorage.setItem('userEmail', this.email)
                        localStorage.setItem('userId', response["id"])
                        localStorage.setItem('group', response["group"][0])
                        this.$router.push({path: "/resumen"})
                    }, err => {
                        console.log(err)
                        this.error.credentials = 'Las credenciales no son válidas.';
                        this.password = '';
                        this.ok.form = false;
                        this.loading = false
                    })
            },
            checkForm: function(){
                if (this.ok.email && this.ok.credentials){
                    this.ok.form = true;
                } else {
                    this.ok.form = false;
                }
            },
            ...mapActions('auth', [
                'userLogin'
            ])
        },
        watch: {
            email: {
                handler: function(val) {
                if (this.re.test(val)) {
                    this.error.email = null;
                    this.ok.email = true;
                } else if (!this.re.test(val)) {
                    this.ok.email = false;
                    if (val.length > 0) {
                        this.error.email = 'Formato de mail inválido.';
                    }
                }
                this.checkForm();
                },
                immediate: true
            },
            password: {
                handler: function(val) {
                if (val.length >= 4) {
                    this.ok.credentials = true;
                    this.error.credentials = null;
                } else {
                    this.ok.credentials = false;
                }
                this.checkForm();
                },
                immediate: true
            }
    }
}
</script>

<style lang="sass">
.forget-password
    display: block
    margin-top: 8px
    margin-bottom: 32px
    color: $secondary
    font-family: $body-font
    font-size: 14px
    @media (max-width: $phone)
        width: 280px
.btn.login.loading
        padding: 4px 16px

</style>